// extracted by mini-css-extract-plugin
module.exports = {"open":"Modal_open__CGJ8n","fadeIn":"Modal_fadeIn__o_0QV","close":"Modal_close__hOQAb","fadeOut":"Modal_fadeOut__4OtCV"};